module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.name) + " ")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form')], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('b-row', {
    staticClass: "mt-4 mb-2"
  }, [_c('b-col', {
    staticClass: "ml-4",
    staticStyle: {
      "border-right": "0.5px solid lightgray"
    },
    attrs: {
      "md": "3"
    }
  }, [_c('div', [_c('h6', {
    staticClass: "greyText",
    staticStyle: {
      "font-size": "15px"
    }
  }, [_c('b', [_vm._v("SUBSCRIPTION")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-envelope mr-2 mainColorText",
    staticStyle: {
      "font-size": "26px"
    }
  }), _c('span', {
    staticClass: "mainColorText",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.getSingleSubscriptions.id))])]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getSingleSubscriptions.request_carrier_name))]), _vm._v(" "), _c('b-row', {
    staticClass: "ml-1"
  }, [_c('b-col', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.bottomright",
      modifiers: {
        "bottomright": true
      }
    }],
    staticClass: "pl-2 py-1 mr-1 mainColorBackground",
    staticStyle: {
      "max-width": "48%",
      "border-radius": "5px"
    },
    attrs: {
      "title": "Creates a secret link to this container that can be shared with others.\n                      Anybody who knows this link will be able to view this container status page without having to log in. \n                      Internal details such as description and tags will NOT be shown"
    }
  }, [_c('i', {
    staticClass: "fa fa-share mr-2 white"
  }), _vm._v(" "), _c('i', {
    staticClass: "white"
  }, [_vm._v("Share this subscription")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-info-circle mt-2",
    staticStyle: {
      "font-size": "15px"
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-col', {
    staticClass: "ml-4",
    attrs: {
      "md": "3"
    }
  }, [_c('h6', {
    staticClass: "greyText",
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("DESCRIPTION & TAGS")])]), _vm._v(" "), _c('p', [_c('i', {
    staticClass: "fa fa-file-text mt-2 greyText",
    staticStyle: {
      "font-size": "20px"
    }
  })]), _vm._v(" "), _c('p', [_c('i', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.bottomright",
      modifiers: {
        "bottomright": true
      }
    }],
    staticClass: "fa fa-tag greyText",
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "title": "Tags"
    }
  })])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-5 ml-4 mr-4 pl-2 py-3 listingTitle"
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope pl-2 mr-2 greyText",
    staticStyle: {
      "font-size": "18px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('b', [_vm._v("Subscription Details")])])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "ml-4 mr-4 pl-2 py-3 listingBody"
  }, [_c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('span', [_c('b', [_vm._v("Carrier ref. # ")]), _vm._v(" "), _c('i', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.bottomright",
      modifiers: {
        "bottomright": true
      }
    }],
    staticClass: "fa fa-info-circle mt-2",
    staticStyle: {
      "font-size": "15px"
    },
    attrs: {
      "title": "Carrier, request type and subscription ref. #"
    }
  }), _vm._v("\n                  " + _vm._s(_vm.getSingleSubscriptions.request_carrier_name) + " - Booking number\n                  " + _vm._s(_vm.getSingleSubscriptions.request_key) + "\n                ")])])], 1), _vm._v(" "), _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('span', [_c('b', [_vm._v("Description : " + _vm._s(_vm.getSingleSubscriptions.descriptive_name))])])])], 1), _vm._v(" "), _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('span', [_c('b', [_vm._v("Sub-account : " + _vm._s(_vm.getSingleSubscriptions.account_name))])])])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "ml-4 mr-4 pl-2 py-3 listingBody"
  }, [_c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('span', [_c('b', [_vm._v("Tags : ")])])])], 1), _vm._v(" "), _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('span', [_c('b', [_vm._v("Contractual ETD @ POL :\n                    "), (_vm.getSingleSubscriptions.contractual_etd_pol) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleSubscriptions.contractual_etd_pol)))]) : _vm._e()])])])], 1), _vm._v(" "), _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('span', [_c('b', [_vm._v("Contractual ETA @ POD :"), (_vm.getSingleSubscriptions.contractual_eta_pod) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleSubscriptions.contractual_eta_pod)))]) : _vm._e()])])])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "ml-4 mr-4 pl-2 py-3 listingBody"
  }, [_c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('span', [_c('b', [_vm._v("Contractual ETA @ DLV :\n                    "), (_vm.getSingleSubscriptions.contractual_eta_dlv) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleSubscriptions.contractual_eta_dlv)))]) : _vm._e()])])])], 1), _vm._v(" "), _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('b', [_vm._v("Subscription Status :\n                  "), (_vm.getSingleSubscriptions.status_verbose) ? _c('span', [_vm._v(_vm._s(_vm.getSingleSubscriptions.status_verbose))]) : _vm._e()])])], 1), _vm._v(" "), _c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('b', [_vm._v("Last update : ")]), _vm._v(" "), (_vm.getSingleSubscriptions.last_carrier_update) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleSubscriptions.last_carrier_update)))]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "ml-4 mr-4 pl-2 py-3 listingBody"
  }, [_c('md-layout', [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('span', [_c('b', [_vm._v("Submitted : ")])]), _vm._v(" "), (_vm.getSingleSubscriptions.created) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(_vm.getSingleSubscriptions.created)))]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-5 ml-4 mr-4 pb-3 listingBody"
  }, [_c('md-layout', {
    staticClass: "listingTitle py-3 pl-2",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('i', {
    staticClass: "fa fa-cube pl-2 mr-2 greyText",
    staticStyle: {
      "font-size": "18px"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('b', [_vm._v("Container list: one container in shipment subscription")])])]), _vm._v(" "), _c('md-layout', {
    staticClass: "listingBody py-3 pl-3 pr-3 pb-5",
    attrs: {
      "md-flex": "100"
    }
  }, [_c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.getSingleSubscriptions.containershipments,
      "fields": _vm.containerFields,
      "primary-key": "container_number"
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "container",
      fn: function(row1) {
        return [_c('span', {
          staticStyle: {
            "color": "blue"
          },
          on: {
            "click": function($event) {
              _vm.getShipmentSubscription(row1.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-cube pl-2 mr-2",
          staticStyle: {
            "color": "#007bff",
            "font-size": "13px"
          }
        }), _vm._v(" "), _c('u', [_vm._v(_vm._s(row1.item.container_number))]), _c('br')]), _vm._v(" "), (row1.item.container_type_str) ? _c('span', [_vm._v(_vm._s("Cont. Type :" + row1.item.container_type_str)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.shipmentsubscription_id) ? _c('span', [_vm._v(_vm._s("Subs. ID :" + row1.item.shipmentsubscription_id)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.lifecycle_status_verbose) ? _c('span', [_vm._v(_vm._s("Lifecycle Status : " + row1.item.lifecycle_status_verbose)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.lifecycle_status_verbose) ? _c('span', [_vm._v(_vm._s("Lifecycle Status :" + row1.item.lifecycle_status_verbose)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.booking_number) ? _c('span', [_vm._v(_vm._s("Booking No. : " + row1.item.booking_number)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.leg1_service) ? _c('span', [_vm._v(_vm._s("Vessel voyage. :" + row1.item.leg1_service.name)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.leg1_voyage) ? _c('span', [_vm._v(_vm._s("Voyage No. : " + row1.item.leg1_voyage)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "type",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.container_type_iso))]), _vm._v(" "), _c('p', [_c('i', {
          staticClass: "fa fa-file-text mt-2 greyText",
          staticStyle: {
            "font-size": "13px"
          }
        })])]
      }
    }, {
      key: "ORI/POL",
      fn: function(row3) {
        return [(row3.item.origin_loc) ? _c('span', [_vm._v(_vm._s("ORI Name : " + row3.item.origin_loc.name)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.origin_loc) ? _c('span', [_vm._v(_vm._s("ORI Code : " + row3.item.origin_loc.locode)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.pol_loc) ? _c('span', [_vm._v(_vm._s("POL Name : " + row3.item.pol_loc.name)), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.pol_loc) ? _c('span', [_vm._v(_vm._s("POL Code : " + row3.item.pol_loc.locode)), _c('br')]) : _vm._e(), _vm._v(" "), _c('p', [_c('i', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottomright",
            modifiers: {
              "bottomright": true
            }
          }],
          staticClass: "fa fa-tag greyText",
          staticStyle: {
            "font-size": "13px"
          },
          attrs: {
            "title": "Tags"
          }
        })])]
      }
    }, {
      key: "POD/DLV",
      fn: function(row4) {
        return [(row4.item.pod_loc) ? _c('span', [_vm._v(_vm._s("POD Name : " + row4.item.pod_loc.name)), _c('br')]) : _vm._e(), _vm._v(" "), (row4.item.pod_loc) ? _c('span', [_vm._v(_vm._s("POD Code : " + row4.item.pod_loc.locode)), _c('br')]) : _vm._e(), _vm._v(" "), (row4.item.dlv_loc) ? _c('span', [_vm._v(_vm._s("DLV Name : " + row4.item.dlv_loc.name)), _c('br')]) : _vm._e(), _vm._v(" "), (row4.item.dlv_loc) ? _c('span', [_vm._v(_vm._s("DLV Code : " + row4.item.dlv_loc.locode)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "ETA/ATA",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s("ETA Estimated") + "\n                      "), (row4.item.pod_vslarrival_planned_initial) ? _c('b', [_vm._v(_vm._s(_vm._f("moment")(row4.item.pod_vslarrival_planned_initial)))]) : _vm._e(), _c('br')]), _vm._v(" "), _c('span', [_vm._v(_vm._s("ETA ACtual") + "\n                      "), (row4.item.pod_vslarrival_detected) ? _c('b', [_vm._v(_vm._s(_vm._f("moment")(row4.item.pod_vslarrival_detected)))]) : _vm._e(), _c('br')])]
      }
    }, {
      key: "transportStatus",
      fn: function(row5) {
        return [_vm._v("\n                    " + _vm._s(row5.item.shipmentsubscription_status_verbose) + "\n                  ")]
      }
    }, {
      key: "status",
      fn: function(row6) {
        return [_vm._v("\n                    " + _vm._s(row6.item.status_verbose) + "\n                    "), _c('p', [_c('i', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottomright",
            modifiers: {
              "bottomright": true
            }
          }],
          staticClass: "fa fa-eye",
          staticStyle: {
            "font-size": "13px"
          },
          attrs: {
            "title": 'Container is actively monitored ' + row6.item.status_verbose
          }
        })])]
      }
    }])
  })], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68b761fe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ocean-insights/affectedSubscriptionCont.vue
// module id = 2705
// module chunks = 0